import { useState, useEffect } from 'react';
import Grid from '@mui/material/Grid';
import ButtonOrder from '../Buttons/ButtonOrder';
import ButtonSwitch from '../Buttons/ButtonSwitch';
import Button from '../Buttons/Button';
import FormSelect from '../Form/FormSelect';
import FormTextField from '../Form/FormTextField';
import JobRecordRowParameters from './JobRecordRowParameters';
import JobRecordRowAttribute from './JobRecordRowAttribute';

const JobRecordRow = props => {
    const [item, setItem] = useState(props.item)
    const [width, setWidth] = useState(0)
    const [options, setOptions] = useState();

    const hasParams = props.node === "source"
    const colsName = 3;

    useEffect(() => {
        setWidth(12 / ((hasParams ? 1 : 0) + (props.attributes || []).length))
        setItem(props.item)
        setOptions(props.options)
    }, [props])

    return (
        <Grid container className="ContainerRow" sx={{
            backgroundColor: item.disabled ? '#eee ': 'auto'
        }}>
            <Grid item>
                <ButtonOrder
                    order={item.column_order}
                    handler={props.handler}
                    name="record_order"
                />
            </Grid>
            <Grid item xs>
                <Grid container>
                    {/* Record Name */}
                    <Grid item xs={colsName}>
                        {hasParams ?
                            <FormSelect
                                name="object"
                                // label="Record"
                                value={item.object}
                                options={options?.names}
                                handler={props.handler}
                                disabled={item.disabled}
                                disableUnderline
                            />
                            :
                            <FormTextField
                                name='object'
                                label="Record"
                                value={item.object || ''}
                                handler={props.handler}
                                header={props.header}
                                disabled={item.disabled}
                                disableUnderline
                            />
                        }
                    </Grid>

                    {/* Record Parameters and Attributes */}
                    <Grid item xs={12 - colsName}>
                        <Grid container>
                            {hasParams &&
                                <Grid item xs={width}>
                                    {options?.params?.[item?.object] &&
                                        <JobRecordRowParameters
                                            width={width}
                                            item={item}
                                            options={options?.params?.[item?.object]}
                                            handler={props.handler}
                                            disabled={item.disabled}
                                        />}
                                </Grid>
                            }
                            {props?.attributes && props.attributes.map((attr, key) => (
                                <Grid item key={key} xs={width} sx={{ px: 0.25 }}>
                                    <JobRecordRowAttribute
                                        item={item}
                                        attr={attr}
                                        handler={props.handler}
                                    />
                                </Grid>
                            ))}
                        </Grid>
                    </Grid>
                </Grid>
            </Grid >
            <Grid item sx={{ fontSize: '0.5rem' }}>
                <Button
                    small
                    type="disabled"
                    handler={() => props.handler({ target: { name: "disabled", value: !item?.disabled } })}
                />
            </Grid >
            <Grid item>
                <Button small type="delete" handler={() => props.handler({ target: { name: "delete" } })} />
            </Grid>
        </Grid>
    )
}
export default JobRecordRow;